var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1366",
    "data-name": "Group 1366",
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.127,
    height: 76.602,
    viewBox: "0 0 146.127 76.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    width: 142.48,
    height: 76.602,
    transform: "translate(2.115)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HealthCare2u_-_Logo",
    "data-name": "HealthCare2u - Logo",
    transform: "translate(0 1.111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bottom_Left_Square",
    "data-name": "Bottom Left Square",
    width: 25.352,
    height: 25.856,
    transform: "translate(37.378 46.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top_Left_Square",
    "data-name": "Top Left Square",
    width: 25.352,
    height: 25.854,
    transform: "translate(37.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bottom_Right_Square",
    "data-name": "Bottom Right Square",
    width: 25.353,
    height: 25.856,
    transform: "translate(83.396 46.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top_Right_Square",
    "data-name": "Top Right Square",
    width: 25.353,
    height: 25.854,
    transform: "translate(83.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H1",
    d: "M416.488,157.676h2.521v2.986h5.314v-2.986h2.521v8.384h-2.521v-3.174h-5.314v3.174h-2.521Z",
    transform: "translate(-416.488 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E1",
    d: "M424.009,157.676H433v1.945H426.53v1.344h6.131V162.7H426.53v1.344h6.619v2.015h-9.14Z",
    transform: "translate(-410.814 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A1",
    d: "M434.725,157.676h3.283l4.519,8.384h-2.805l-.782-1.483h-5.11l-.739,1.483h-2.816Zm.046,5.1h3.225l-1.635-3.151Z",
    transform: "translate(-406.088 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M438.416,157.676h2.521v6.23H446.6v2.154h-8.188Z",
    transform: "translate(-399.946 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M443.278,157.676h9.607v2.084h-3.544v6.3H446.82v-6.3h-3.542Z",
    transform: "translate(-396.278 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H2",
    d: "M450.028,157.676h2.521v2.986h5.314v-2.986h2.521v8.384h-2.521v-3.174h-5.314v3.174h-2.521Z",
    transform: "translate(-391.186 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M457.445,160.658c0-2.457,1.353-3.034,3.623-3.034h2.965c3.588,0,4.054.787,4.031,3.161h-2.523v-.233c0-.6-.43-.775-1.181-.775h-2.747c-1.328,0-1.579.637-1.579,1.678v.9c0,1.217.251,1.68,1.442,1.68h2.691c1.137,0,1.477-.116,1.477-1.159h2.521v.787c0,1.413-.5,2.526-3.032,2.526h-4.067c-2.27,0-3.623-.58-3.623-3.034Z",
    transform: "translate(-385.591 -124.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A2",
    d: "M469.063,157.676h3.281l4.519,8.384h-2.805l-.782-1.483h-5.11l-.737,1.483H464.61Zm.044,5.1h3.226l-1.635-3.151Z",
    transform: "translate(-380.186 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M472.752,157.676h7.609c1.942,0,2.465.984,2.465,2.489v.533c0,1.124-.251,1.784-1.409,2.061v.023c.749.14,1.374.474,1.374,1.854v1.424h-2.521v-1.007c0-.88-.249-1.17-1.033-1.17h-3.963v2.177h-2.521Zm2.521,4.122h4.168c.681,0,.932-.277.932-.88v-.277c0-.742-.365-.88-1.159-.88h-3.94Z",
    transform: "translate(-374.044 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E2",
    d: "M480.111,157.676h8.995v1.945h-6.474v1.344h6.132V162.7h-6.132v1.344h6.621v2.015h-9.142Z",
    transform: "translate(-368.493 -124.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    d: "M486.8,161.195c0-1.031.66-1.714,2.284-1.83l2.882-.186c1.84-.114,1.965-.15,1.965-.971,0-.683-.067-.834-1.681-.834h-1.668c-1.067,0-1.4.161-1.4,1.031v.358H486.8v-.984c0-1.655.954-2.211,3.226-2.211h3.316c2.361,0,2.976.717,2.976,2.467,0,2.465-.444,2.882-3.384,3.045l-2.6.14c-1.055.057-1.214.265-1.214,1.018h7.314v1.807H486.8Z",
    transform: "translate(-363.444 -126.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M493.878,157.676H496.4v4.84c0,1.066.374,1.483,1.407,1.483h2.5c1.033,0,1.409-.417,1.409-1.483v-4.84h2.521v5.4c0,2.084-1.056,3.081-3.374,3.081h-3.61c-2.318,0-3.372-1-3.372-3.081Z",
    transform: "translate(-358.107 -124.813)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/LogoWhite.2599e6f97fbc8ef64fbe7e1f82f577be.svg";
export { ForwardRef as ReactComponent };